<template>
  <div class="page-content">
    <div class="content-wrapper">
      <!-- Page header -->
      <div class="page-header mb-2">
        <div class="page-header-content header-elements-md-inline">
          <div class="page-title d-flex">
            <h4 class="font-weight-semibold">Undeleted pages</h4>
          </div>
        </div>
      </div>
      <!-- /page header -->

      <!-- Content area -->
      <div class="content pt-0">
        <div class="row mb-2">
          <div class="col-12">
            <div class="card p-2">
              <label for="pageName">Page Name</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  id="pageName"
                  placeholder="Page name"
                  v-model="pageName"
                />
                <div class="input-group-append">
                  <button class="btn btn-primary" @click="createPage">
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xl-12">
            <div class="card">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Created at</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="isLoading">
                      <td colspan="8">
                        <loading></loading>
                      </td>
                    </tr>
                    <tr v-else v-for="(page, idx) in pages" :key="page._id">
                      <td>{{ idx + 1 }}</td>
                      <td>{{ page.page_name }}</td>
                      <td>
                        {{ moment(page.createdAt).format('DD/MM/YYYY HH:mm') }}
                      </td>
                      <td>
                        <button
                          type="button"
                          class="btn"
                          @click="deletePage(page._id)"
                        >
                          <i class="far fa-trash-alt"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /content area -->
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import serviceRoutes from '../service-routes'
import Loading from '../components/Loading.vue'

export default {
  components: { Loading },
  data () {
    return {
      isLoading: true,
      pages: [],
      pageName: ''
    }
  },
  async mounted () {
    await this.init()
    this.isLoading = false
  },
  methods: {
    moment,
    async init () {
      let res = await serviceRoutes.getUndeletedPages()
      this.pages = res.data.data
    },
    async createPage () {
      serviceRoutes
        .createUndeletedPage({ page_name: this.pageName })
        .then(() => {
          this.$swal({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: 'Page was added',
            showConfirmButton: false,
            showCloseButton: true
          })
          this.init()
        })
        .catch(error => {
          this.$swal({
            toast: true,
            position: 'top-end',
            icon: 'error',
            title: error.response.data.message,
            showConfirmButton: false,
            showCloseButton: true
          })
        })
    },
    async deletePage (id) {
      this.$swal({
        // toast: true,
        position: 'center',
        icon: 'warning',
        title: 'Do you want to delete this?',
        showConfirmButton: true,
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          await serviceRoutes.deleteUndeletedPage(id)
          this.init()
        }
      })
    }
  }
}
</script>
